import { OwnerTypes } from '@mews-commander/data-access';

export const getOwnerType = (values: string[]): OwnerTypes => {
    if (Array.isArray(values) && values.length === 1) {
        return OwnerTypes[values[0] as keyof typeof OwnerTypes] || OwnerTypes.Unknown;
    }

    if (Array.isArray(values) && (values.length === 2 || values.length === 0)) {
        return OwnerTypes.All;
    }

    return OwnerTypes.Unknown;
};
